export default {
  finance: {
    salesInvoices: 'Sales Invoices',
    FVS: 'FVS',
    lastModification: 'Last modification to approve',
    verification: 'Verification',
    amountToCorrect: 'Amount to correct',
    amountToInvoice: 'Amount to invoice',
    forContractor: 'for contractor',
    andBudget: 'and budget',
    toInvoice: 'to invoice',
    askCreateInvoiceDraft:
      'Warning: A draft correction for sales invoice no. {{number}} will be automatically created. Are you sure you want to continue?',
    issuingCorrection: 'Issue correction',
    saveAndStepForward: 'Save and move forward',
    paymentForm: 'Payment form',
    paymentDate: 'Payment deadline',
    paymentDateFromReceive: 'Payment date from the day of receipt',
    paymentReceivedDate: 'Payment date',
    invoiceNumber: 'Invoice number',
    correctedInvoiceNumber: 'Correcting invoice number',
    nip: 'VAT ID',
    askDeleteInvoiceDraft:
      'Are you sure you want to delete the displayed invoice draft?',
    documentCodes: 'Document codes',
    gtuCode: 'GTU code',
    financialAccount: 'Financial account',
    was: 'was',
    is: 'is',
    commission: 'Commission',
    commissionFinancialAccount: 'Commission financial account',
    sumToInvoiceSaleAndCommission:
      'Total amount for invoicing sales and commission',
    mergedPositionsSameAccount:
      'Merged positions must be assigned to the same financial account and belong to',
    mergePositions: 'Merge positions',
    askMergePositions: 'Are you sure you want to merge positions?',

    askResetPositions: 'Are you sure you want to reset positions?',
    clonePosition: 'Clone position',
    clonePositionOnce: 'Clone once',
    clonePositionMultiple: 'Clone multiple times',
    clonePositionCount: 'Number of copies to be created',
    resetPositions: 'Reset all positions',
    mergePositionsBy: 'Merge positions by',
    mergeSelectedPositionsBy: 'Merge selected positions by',
    netAmount: 'Net amount',
    vat: 'VAT rate',
    netAmountInCurrency: 'Net amount in currency',
    grossAmount: 'Gross amount',
    sumToInvoice: 'Total amount to invoice',
    correctionAmount: 'Correction amount',
    print: 'Print',
    fvsData: 'Data for FVS',
    duplicate: 'Duplicate',
    copy: 'Copy',
    addedWithinBudget: 'added within budget',
    noInvoices: 'No sales invoices in the system.',
    buyerName: 'Buyer name',
    net: 'Net',
    handleChangeToSent: `Are you sure you want to change this invoice's status to 'Sent'?`,
    handleChangeToDraft: `Are you sure you want to change this invoice's status to 'Draft'?`,
    handleChangeToGenerated: `Are you sure you want to change this invoice's status to 'Approved'?`,
    markAsSent: 'Mark as sent',
    undoApproval: 'Undo approval',
    undoSend: 'Undo send',
    correctionReason: 'Reason for issuing correction',
    correctionReasonDesc: 'Description of the reason for issuing correction',
    onePositionOnInvoice: 'One position on invoice',
    textOverItems: 'Text to print above items',
    documentApproved: 'The document will be approved with the issue date',
    andSalesDate: 'and sales date',
    diffVatRates:
      'Different VAT rates are present for items in the invoice. To continue, uncheck the box',
    orSetSameVatRates: 'or set the same VAT rates for items.',
    wrongTryAgain: 'Something went wrong. Please try again.',
    drafts: 'Drafts',
    approved: 'Approved',
    waitingForKSeF: 'Waiting for KSeF',
    rejectedFromKSeF: 'Rejected from KSeF',
    offlineKSeF: 'Offline KSeF',
    all: 'All',
    exportFvs: 'Export Sales Invoices',
    xmlClosed: `Attention! Sending approved invoices to Symphony Handel is available
              in the "Export FVS to Symphony Handel" menu. XML packages are no longer
              generated and used.`,
    invoicesDomesticToSent: 'Domestic sales invoices (FVS) to send',
    createInvoicesDomesticToSent:
      'Create XML with domestic sales invoices (FVS)',
    invoicesForeignToSent: 'Foreign sales invoices (FVS) to send',
    createInvoicesForeignToSent: 'Create XML with foreign sales invoices (FVS)',
    packagesFVS: 'Sales invoices (FVS) Packages',
    basicData: 'Basic data',
    invoicePositions: 'Invoice positions',
    summary: 'Summary',
    unwrittenUppercase: 'UNSAVED',
    sentEmail: 'Sent by email to addresses:',
    archiveUpperCase: 'ARCHIVE',
    packageWithNumber: 'in package with system number',
    toSHWithDate: 'to SH on date',
    saleInvoice: 'Sales invoice',
    correction: 'Correction',
    toSaleInvoice: 'to sales invoice',
    invoicesToCorrect: 'Sales invoices to correct',
    alertDraftInvoiceCorrectionCreation:
      'Warning: A draft correction for sales invoice no. {{number}} will be automatically created. Are you sure you want to continue?',
    noPositionsToInvoice: 'No available positions to invoice.',
    atLeastOneValueInPositionsFilled:
      'At least one position must have a sales amount or commission amount greater than 0.',
    position: 'Position',
    noSymphonyCode: 'No Symphony code for the contractor',
    noSymphonyCodeForRecipient:
      'No Symphony code for the recipient of the invoice and company',
    noSymphonyOrRecipientCode:
      'No Symphony code for the contractor or recipient',
    correctionToInvoice: 'Correction to invoice',
    invoicesInPackage:
      'Invoices included in package with system no. {{number}} from {{date}}',
    createXML10FVS: 'Create XML with domestic sales invoices (FVS) (10 oldest)',
    oldest10: '10 oldest',
    askCreatePackage:
      'Are you sure you want to create sales invoices (FVS) package?',
    noUnsentInvoices: 'No unsent sales invoices in the system.',
    export: 'Export',
    domestic: 'Domestic',
    foreign: 'Foreign',
    openInstructionNewWindow: 'Open the invoicing instruction in a new window',
    invoiceInstruction: 'Invoicing instruction',
    invoiceInstructionShort: 'Inv. instr.',
    rejected: 'Rejected',
    salesInvoicing: 'Sales - invoicing',
    salesInvoicingFileName: 'SalesInvoicing',
    hideInvoiced: 'Hide invoiced',
    changeToReady: 'Change to actual status',
    statusInDocs: 'Status confirmed in documents',
    hasCorrection: 'Correction issued for FVS',
    salesTotal: 'Sales Total',
    amountToInvoiced: 'Amount to Invoice',
    commentMediaPlanner: 'Mediaplanner Comment',
    commentFinance: 'Finance Comment',
    markerForFinance: 'Change state to "Withdrawn"',
    askChangeToWithdrawn:
      'Are you sure you want to change state to "Withdrawn"?',
    sentToSymphonyHandelTs: 'Sent to Symphony Handel',
    noSentInvoices: 'No sent sales invoices in the system.',
    sysNumber: 'Invoice sys. no.',
    invoiceStatus: 'Invoice status',
    sentByEmail: 'Sent by email',
    insertNamesFromClipboard: 'Paste position names',
    insertAmountsFromClipboard: 'Paste position amounts',
    insertFromExcel: 'Paste data copied from Excel',
    tooManyValues:
      'Too many values pasted. Maximum number of rows: {{maxRows}}, pasted: {{count}}',
    invalidNumberFormat:
      'Numbers expected. Invalid values: {{values}}{{suffix}}',
    invalidNumberFormatMore: '(and {{count}} more)',
    pasteDataLabel: 'Paste data (each value on a separate line):',
    fillAllFieldsWithSales: 'Fill in all visible fields with sales amount',
    fillNotAssignedAmountWithSales: 'Fill with sales amount',
    fillAllFieldsWithCommission:
      'Fill in all visible fields with commission amount',
    fillNotAssignedAmountWithCommission: 'Fill with commission amount',
    subjectToKSeF: 'Subject to KSeF submission',
    rejectedFromKSeFNotToSH:
      'Invoice rejected by KSeF. Not subject to re-sending to Symfonia Handel.',
    rejectionReason: 'Rejection reason in KSeF',
    noRejectionReason: 'No information in POK about the rejection reason',
    waitingForKSeFNumber: 'Waiting for KSeF number assignment',
    offline: 'OFFLINE',
    ksefNumber: 'KSeF number',
    ksefAcceptanceDate: 'KSeF no. assignment date',
    openInvoicePrint: 'Open invoice print',
    previewInvoice: 'Invoice preview',
    paymentStatus: 'Payment status',
    paymentsFor: 'Payments for invoice',
    fromDate: 'dated',
    invoiceGrossAmount: 'Invoice gross amount',
    totalPaidAmount: 'Total paid',
    remainingBalance: 'Remaining balance',
    remainingBalanceTooltip: 'Remaining balance according to accounting data',
    paymentDueDate: 'Payment due date',
    paymentDueDateTooltip: 'Estimated payment due date',
    paymentAmount: 'Payment amount',
    paymentType: 'Payment type',
    currentBalance: 'Current balance',
    paymentsList: 'Payments list',
    correctionDate: 'Correction issue date',
    lp: 'No.',
    orderNumbers: 'Orders to invoice',
    orderNumber: 'Order number',
    addOrderNumber: 'Add order number',
    editOrderNumber: 'Edit order number',
    deleteOrderNumber: 'Delete order number',
    deleteOrderNumberConfirm:
      'Are you sure you want to delete this order number?',
    noOrderNumbers: 'No order numbers',
    orderDate: 'Order date',
    purchaserDataChangedAlert:
      'The purchaser data has changed since the corrected invoice was issued.',
    recipientDataChangedAlert:
      'The recipient data has changed since the corrected invoice was issued.',
    formalCorrectionWillBeIssued: 'A formal data correction will be issued.',
    rejectedFromKSeFEditWarning:
      'Warning: changes made in POK on the KSeF-rejected invoice are not automatically sent to Symfonia Handel.',
    rejectedFromKSeFEditSteps:
      'Action order: 1. Data correction in POK and setting the invoice status to "Sent" → 2. Data correction in Symfonia Handel → 3. Re-send to KSeF from Symfonia Handel.',
  },
  symphony: {
    symphonyNew: 'New code',
    code: 'Code',
    codes: 'Symphony codes',
    noSymphonyForClient: 'No Symphony codes for this contractor.',
    symphonyEdit: 'Edit code',
    symphonyAdd: 'Add new code',
    clientsWithSymphony: 'Contractors - Symphony',
    clientsNoSymphonyFVS: 'Contractors without Symphony code (Sales invoices)',
    clientsNoSymphonyFVZ:
      'Contractors without Symphony code (Purchase invoices)',
    sendUnsentFVSAll: 'Send all sales invoices',
    sendUnsentFVS: 'Send selected sales invoices ({{number}})',
    sendingFVSToSymfoniaFinished:
      'Sending sales invoices to Symphony Handel staging tables has been completed.',
    exportFVSToSymfonia: 'Export sales invoices to Symphony Handel',
    FVSToSend: 'FVS to send',
    askSendToSymphony:
      'Are you sure you want to send the invoices to the Symphony Handel staging database?',
    sentFVS: 'Sent FVS',
    noUnsentFVS: 'No unsent sales invoices to Symphony Handel.',
    noSentFVS: 'No sent sales invoices to Symphony Handel.',
    symphonyNumberNotFound:
      'Symphony number not found for the settled contractor and company',
    invoiceWontBeImported:
      'The invoice will not be exported to the Symphony system after approval.',
    clients: 'Contractors',
    noClients: 'No contractors',
    importErrors:
      'Errors importing sales invoices (FVS) to the Symphony Handel',
    noImportErrors:
      'No errors importing sales invoices (FVS) to the Symphony Handel',
    askResendToSymphony:
      'Are you sure you want to resend the sales invoice (FVS) to the Symphony Handel?',
    resendToSymphony: 'Resend to the Symphony Handel',
    warningResend:
      'WARNING! The invoice has already been sent to Symphony Handel after the date of this import error.',
  },
  sendEmail: {
    toClients: 'Sending emails to contractors',
    waitingToSendWithEmail: 'Waiting to send',
    waitingToSendWithoutEmail: 'Without defined email addresses',
    waitingToSendWithMoreEmail: 'With more than one email address',
    sendAllUnsent: 'Send all FVS',
    sendAllUnsentInOneEmail: 'Send all FVS in one email',
    sendUnsent: 'Send selected FVS ({{number}})',
    sendUnsentInOneEmail: 'Send selected FVS in one email ({{number}})',
    askSendEmails: 'Are you sure you want to send emails?',
    askSendEmailsManyInOneMail:
      'Are you sure you want to send invoices to contractors in one email message?',
    askSendEmail: 'Are you sure you want to send the email again?',
    emailSubject: 'Custom email subject',
    emailText: 'Custom email content',
    attachments: 'Custom email attachments',
    emailTextSubject: 'Custom email content, subject or attachments',
    editEmailTextSubject:
      'Editing custom email content, subject or attachments',
    addEmailTextSubject: 'Adding custom email content, subject or attachments',
    newEmailNote: 'New custom email content, subject or attachments',
    editEmailNote: 'Editing custom email content, subject or attachments',
    askDeleteEmailText:
      'Are you sure you want to delete the custom email content, subject and attachments?',
    to: 'To',
    cc: 'CC',
    emailTextSubjectRequired:
      'Please provide the email content, subject or attachments.',
    chooseEmailAddress: 'Choose email addresses',
    changeEmailAddress: 'Change email addresses',
    sentEmails: 'Sent emails',
    sendingInProgress: 'Sending email messages in progress...',
    sendAgain: 'Send email again',
    warningSelectEmailAddress:
      'Warning: You must select email addresses to which the email will be sent to the contractor.',
    emailFrom: 'Email from',
    emailWillBeSend: 'The email will be sent to addresses:',
    toAddress: 'Address to',
    ccAddress: 'CC address',
    fromAddress: 'Sent from address',
    noEmailAddresses: 'No email addresses set for sending invoice (FVS).',
    subject: 'Email subject',
    message: 'Email message',
    sendAgainFVS: 'Send again sales invoice (FVS)',
    sendAgainFVSDuplicate: 'Send sales invoice DUPLICATE (FVS)',
    invoiceDuplicate: 'Invoice duplicate',
    sendInOneEmail: 'Sending selected FVS in one email',
    fileUpload: 'Upload files',
    customEmail: 'Custom email',
    clientsEmails: 'Contractors email addresses',
  },
} as const;
